<!-- Indicate a message -->
<script setup lang="ts">
import { computed } from 'vue';
import { DisplayStyle, TextDisplayStyle } from '../../Enums/UiEnums';
import { bootstrapTextClass, themeIconsClass } from '../../lib/StyleHelpers'

    const props = withDefaults(defineProps<{
            displayStyle?: DisplayStyle | TextDisplayStyle | string, 
            showIcon?: boolean,
            bold?: boolean,
            italic?: boolean,
            title?: string
        }>(), {
            //displayStyle: DisplayStyle.Primary,
            showIcon: false
        });

    const emits = defineEmits<{
        (e: "click"): void
    }>();

    const spanStyle = computed<string[]>(() => [props.bold ? "font-weight:bold" : "", props.italic ? "font-style:italic" : ""]);
</script>

<template>
    <span :class="bootstrapTextClass(props.displayStyle)" @click="emits('click')" :style="spanStyle" :title="props.title">
        <i v-if="showIcon" :class="themeIconsClass(props.displayStyle ?? DisplayStyle.Primary)" aria-hidden="true"></i>
        <slot></slot>
    </span>
</template>
